<template lang="pug">
  .module__main
    .module__title Завершенные
    .module-content__container
      .filters__container
        .users__container(v-if="isAdmin")
          .filter__content
            el-select(v-model="user" placeholder="Пользователь")
              el-option(v-for="current in finishedUsers" :label="current" :value="current" :key="`filter-user-${current}`")
        .date__container
          el-date-picker(
            v-model="dates"
            type="datetimerange"
            range-separator="-"
            start-placeholder="От"
            end-placeholder="До"
          )
        el-button(type="primary" @click="loadHistory()" :disabled="!isCanSearch") Запросить
      .stats__block(v-if="finishedHistory.loaded")
        .stats__container
          .stats__title Общая статистика
          .stat__container
            .stat__title Заявок:
            .stat__value {{ finishedHistory.stats.total.orders_amount }}
          .stat__container
            .stat__title Завершено:
            .stat__value {{ finishedHistory.stats.total.finished_amount }}
          .stat__container
            .stat__title Ошибка завершения:
            .stat__value {{ finishedHistory.stats.total.finish_error_amount }}
          .stat__container
            .stat__title Оборот:
            .stat__value {{ `${finishedHistory.stats.total.turnover_fiat} р. (${finishedHistory.stats.total.turnover_crypto} BTC)` }}
          .stat__container
            .stat__title Оборот завершенных:
            .stat__value {{ `${finishedHistory.stats.total.finished_turnover_fiat} р. (${finishedHistory.stats.total.finished_turnover_crypto} BTC)` }}
          .stat__container
            .stat__title Оборот ошибки завершения:
            .stat__value {{ `${finishedHistory.stats.total.finish_error_turnover_fiat} р. (${finishedHistory.stats.total.finish_error_turnover_crypto} BTC)` }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  LOAD_FINISHED_HISTORY,
  LOAD_FINISHED_USERS
} from "../../store/const/user";

export default {
  name: 'Finished',
  data() {
    return {
      user: '',
      dates: '',
    }
  },
  mounted() {
    if (this.isAdmin) {
      this.loadFinishedUsers();
    } else {
      this.user = this.username;
    }
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('user', [
      'isAdmin',
      'username',
      'finishedHistory',
      'finishedUsers',
    ]),
    isFinishedHistoryLoading() {
      return this.loading(LOAD_FINISHED_HISTORY) === 'loading';
    },
    isFinishedUsersLoading() {
      return this.loading(LOAD_FINISHED_USERS) === 'loading';
    },
    formattedFinishedHistory() {
      return this.finishedHistory.history.map((current) => {
        const created = new Date(current.created);
        const updated = new Date(current.updated);
        const timeZoneOffset = created.getTimezoneOffset();
        const mskOffset = 180;
        created.setMinutes(created.getMinutes() + timeZoneOffset + mskOffset);
        updated.setMinutes(updated.getMinutes() + timeZoneOffset + mskOffset);
        return {
          ...current,
          created: `${created.toLocaleDateString()} ${created.toLocaleTimeString()}`,
          updated: `${updated.toLocaleDateString()} ${updated.toLocaleTimeString()}`,
        }
      })
    },
    formattedDates() {
      if (this.dates && Array.isArray(this.dates)) {
        const [from, to] = this.dates;
        return {
          from: {
            year: from.getFullYear(),
            month: from.getMonth(),
            day: from.getDate(),
            hours: from.getHours(),
            minutes: from.getMinutes(),
            seconds: from.getSeconds(),
          },
          to: {
            year: to.getFullYear(),
            month: to.getMonth(),
            day: to.getDate(),
            hours: to.getHours(),
            minutes: to.getMinutes(),
            seconds: to.getSeconds(),
          },
        };
      } else {
        return false;
      }
    },
    isCanSearch() {
      return this.formattedDates && this.user;
    },
  },
  methods: {
    ...mapActions('user', {
      loadFinishedHistory: LOAD_FINISHED_HISTORY,
      loadFinishedUsers: LOAD_FINISHED_USERS,
    }),
    async loadHistory() {
      if (this.isFinishedHistoryLoading) {
        return;
      }
      const request = await this.loadFinishedHistory({
        user: this.user,
        dates: this.formattedDates,
      });
      if (!request.success) {
        this.$message.error(`Ошибка загрузки статистики: ${request.message || 'Неизвестная ошибка'}`);
      }
    },
  }
};
</script>
<style scoped>
.filters__container {
  display: flex;
  padding: 5px;
  background-color: #efefef;
  align-content: center;
}

.stats__block {
  display: flex;
  flex-wrap: wrap;
}

.stats__container {
  padding: 8px;
  margin: 5px 4px;
  border-radius: 10px;
  background-color: #efefef;
  width: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.stats__title {
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 5px;
}

.stat__container {
  font-family: monospace;
}

.date__container {
  margin: 0 10px;
}

.stat__title {
  font-weight: 500;
  margin-right: 5px;
  display: inline-block;
}

.stat__value {
  display: inline-block;
}

</style>
